<template>
    <div>
        <div class="carousel-container">
            <el-carousel :height="computeHeight">
                <el-carousel-item v-for="(item, index) in sliders" :key="index">
                    <div class="image-container">
                        <img :src="item.img" class="slider_img">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div id="解决方案" class="solve head-label">
            <div style="text-align: center;" class="font_size_24">
                解决方案
            </div>
        </div>
        <!-- 盒子 -->
        <div class="border_parent">
            <el-row :gutter="10">
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[0].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[0].title}}</div>
                        <div class="border_content_one">{{images[0].content[0]}}</div>
                        <div class="border_content_two">{{images[0].content[1]}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[1].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[1].title}}</div>
                        <div class="border_content_one">{{images[1].content[0]}}</div>
                        <div class="border_content_two">{{images[1].content[1]}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border">
                        <div class="border_img_parent">
                            <img :src="images[2].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[2].title}}</div>
                        <div class="border_content_one">{{images[2].content[0]}}</div>
                        <div class="border_content_two">{{images[2].content[1]}}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6">
                    <div class="border" style="margin-right: 0">
                        <div class="border_img_parent">
                            <img :src="images[3].img" class="img_border"/>
                        </div>
                        <div class="border_title">{{images[3].title}}</div>
                        <div class="border_content_one">{{images[3].content[0]}}</div>
                        <div class="border_content_two">{{images[3].content[1]}}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 手机端商品展示 -->
        <!--<div id="产品微观" class="head-label">-->
            <!--<div style="text-align: center;" class="font_size_24">-->
                <!--产品介绍-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="product_mobile">-->
            <!--<el-row>-->
                <!--<el-col :xs="24" :sm="12">-->
                    <!--<div class="product_mobile_content" style="padding-top: 50%;position: relative;">-->
                        <!--<div style="position: absolute;left: 0;top: 0;right: 0;bottom: 0;display: flex;-->
                        <!--justify-content: center;align-items: center;flex-direction: column;">-->
                            <!--<div class="product_mobile_title font_size_30">{{products[0].title}}</div>-->
                            <!--<div class="product_font_style product_mobile_content_one"-->
                                 <!--v-for="(content, index) in products[0].content" :key="index">{{content}}-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</el-col>-->
                <!--<el-col :xs="24" :sm="12">-->
                    <!--<el-row :gutter="20">-->
                        <!--<el-col span="12">-->
                            <!--<img :src="products[0].img[0].left" style="width: 100%;">-->
                        <!--</el-col>-->
                        <!--<el-col span="12">-->
                            <!--<img :src="products[0].img[0].right" style="width: 100%;">-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                <!--</el-col>-->
            <!--</el-row>-->
        <!--</div>-->
        <!--&lt;!&ndash; 后台管理 &ndash;&gt;-->
        <!--<div class="product_pc">-->
            <!--<el-row>-->
                <!--<el-col :xs="24" :sm="12">-->
                    <!--<div class="product_pc_one">-->
                        <!--<div class="product_mobile_title font_size_30">{{manages[0].title}}</div>-->
                        <!--<div style="margin-top: 20px" class="product_font_style">{{manages[0].content[0]}}</div>-->
                        <!--<div style="margin-top: 10px" class="product_font_style">{{manages[0].content[1]}}</div>-->
                        <!--<div style="margin-top: 10px" class="product_font_style">{{manages[0].content[2]}}</div>-->
                        <!--<div style="margin-top: 10px" class="product_font_style">{{manages[0].content[3]}}</div>-->
                        <!--<div style="margin-top: 10px" class="product_font_style">{{manages[0].content[4]}}</div>-->
                    <!--</div>-->
                <!--</el-col>-->
                <!--<el-col :xs="24" :sm="12">-->
                    <!--<img :src="manages[0].img[0]" class="product_pc_img"/>-->
                <!--</el-col>-->
            <!--</el-row>-->
        <!--</div>-->
        <!-- 产品特点-->
        <div id="产品特点" class="product_spec_title head-label">
            <div style="text-align: center;" class="font_size_24">
                产品特点
            </div>
        </div>
        <div class="product_spec_parent">
            <div class="border_one border_spec"  style="margin-right: 30px">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[0].img" style="width: 50px;height: 50px"/>
                    <div style="margin-left:10px; font-weight: bold;" class="font_size_24">
                        {{spec.product[0].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[0].contents[0]}}
                    </div>
                    <div class="border_spec_inner_mid">
                        {{spec.product[0].contents[1]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[0].contents[2]}}
                    </div>
                </div>
            </div>
            <!--<div>-->
                <!--<img :src="computeArrowImg" class="border_spec_img"/>-->
            <!--</div>-->
            <div class="border_spec" style="margin-right: 30px">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[1].img" style="width: 50px;height: 50px"/>
                    <div style="margin-left:10px; font-weight: bold;" class="font_size_24">
                        {{spec.product[1].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[1].contents[0]}}
                    </div>
                    <div class="border_spec_inner_mid">
                        {{spec.product[1].contents[1]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[1].contents[2]}}
                    </div>
                </div>
            </div>
            <!--<div>-->
                <!--<img :src="computeArrowImg" class="border_spec_img"/>-->
            <!--</div>-->
            <div class="border_spec" style="margin-right: 30px">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[2].img" style="width: 50px;height: 50px"/>
                    <div style="margin-left:10px; font-weight: bold;" class="font_size_24">
                        {{spec.product[2].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[2].contents[0]}}
                    </div>
                    <div class="border_spec_inner_mid">
                        {{spec.product[2].contents[1]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[2].contents[2]}}
                    </div>
                </div>
            </div>
            <!--<div>-->
                <!--<img :src="computeArrowImg" class="border_spec_img"/>-->
            <!--</div>-->
            <div class="border_spec">
                <div class="border_spec_inner_one">
                    <img :src="spec.product[3].img" style="width: 50px;height: 50px"/>
                    <div style="margin-left:10px; font-weight: bold;" class="font_size_24">
                        {{spec.product[3].title}}
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div class="border_spec_content_one">
                        {{spec.product[3].contents[0]}}
                    </div>
                    <div class="border_spec_inner_mid">
                        {{spec.product[3].contents[1]}}
                    </div>
                    <div class="border_spec_inner_last">
                        {{spec.product[3].contents[2]}}
                    </div>
                </div>
            </div>
        </div>
        <!-- 产品案例-->
        <!--<div id="产品案例" class="cooperation head-label">-->
            <!--<div style="text-align: center;" class="font_size_24">-->
                <!--产品案例-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="cooperation_parent">-->
            <!--<div style="width: auto; height: auto; margin: auto">-->
                <!--<img style="height: 160px;width: 160px;" src="../../static/other/partner_01.jpg"/>-->
                <!--<img style="height: 160px;width: 160px;margin-left: 30px;" src="../../static/other/partner_02.jpg"/>-->
            <!--</div>-->
        <!--</div>-->
        <!-- 关于我们-->
        <div id="关于我们" class="about_me head-label">
            <div style="text-align: center;" class="font_size_24">
                关于我们
            </div>
        </div>
        <div class="about-content">
            <div class="about-text">
                <p>南京钟明网络科技有限公司成立于2015年，是一家专注于软件开发与运维服务的高新技术企业。公司总部位于南京，业务范围覆盖全国。</p>
                <p>我们拥有一支经验丰富、技术精湛的专业团队，致力于为客户提供全方位的信息化解决方案。从需求分析、系统设计到开发实施和后期运维，我们为客户提供全生命周期的服务支持。</p>
                <p>多年来，我们始终坚持以技术创新为核心，以客户需求为导向，已成功为教育、制造、建筑、财务等多个行业提供了优质的软件产品和技术服务。</p>
            </div>
            <!--<div class="about-image"></div>-->
        </div>

        <div class="values">
            <div class="value-card">
                <div class="value-icon"><i class="fas fa-bullseye"></i></div>
                <h3>我们的使命</h3>
                <p>通过技术创新，为客户提供卓越的软件产品和服务，助力企业数字化转型升级。</p>
            </div>
            <div class="value-card">
                <div class="value-icon"><i class="fas fa-eye"></i></div>
                <h3>我们的愿景</h3>
                <p>成为国内领先的软件开发和运维服务提供商，推动行业技术进步与发展。</p>
            </div>
            <div class="value-card">
                <div class="value-icon"><i class="fas fa-hand-holding-heart"></i></div>
                <h3>我们的价值观</h3>
                <p>客户至上、技术创新、诚信合作、追求卓越、共享共赢。</p>
            </div>
        </div>
        <!--<div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">-->
            <!--<div style="display: flex; flex-direction: column;width: 100%;">-->
                <!--<p class="about_me_p">{{company[0]}}</p>-->
                <!--<p class="about_me_p">{{company[1]}}</p>-->
                <!--<p class="about_me_p">{{company[2]}}</p>-->
                <!--<p class="about_me_p">{{company[3]}}</p>-->
            <!--</div>-->
        <!--</div>-->

    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                images: [
                    {
                        img: require('../../static/other/MDM.svg'),
                        title: "MDM解决方案",
                        content: ["设备指令下发", "支持多级租户"]
                    },
                    {
                        img: require('../../static/other/教培.svg'),
                        title: "教培解决方案",
                        content: ["课程预约排课", "课程定时提醒"]
                    },
                    {
                        img: require('../../static/other/生产.svg'),
                        title: "生产管理解决方案",
                        content: ["提高生产效率", "降低运营成本"]
                    }, {
                        img: require('../../static/other/电商.svg'),
                        title: "电商解决方案",
                        content: ["全渠道电商平台", "一站式服务支持"]
                    }
                ],
                products: [
                    {
                        img: [
                            {
                                left: require('../../static/other/1.jpg'),
                                right: require('../../static/other/2.jpg'),
                            },
                            {
                                left: require('../../static/other/3.jpg'),
                                right: require('../../static/other/4.jpg'),
                            },
                            {
                                left: require('../../static/other/5.jpg'),
                                right: require('../../static/other/6.jpg'),
                            }
                        ],
                        title: "手机端商品展示，强大的商品规格设计",
                        content: [
                            "商品热销分类显，分类导航显示所有分类",
                            "热销商品优先排序 商城首页轮播自定义",
                            "单品、多规格、加料、属性、多价格展示",
                            "商品分类列表支持虚拟列表，滚动众享丝滑",
                            "无需注册会员，商品在线购买支付"
                        ]
                    }
                ],
                manages: [
                    {
                        img: [require('../../static/other/product_info.jpg')],
                        title: "小程序+公众号一体化微信商城管理平台",
                        content: ["公众号菜单自定义发布 微信图文图片素材管理", "商品多规格SKU自定义上架 分类自定义设置",
                            "用户管理 用户自定义标签，了解用户消费行为",
                            "订单管理 实时掌握商品交易详情", "物流闪电发货 实时掌握物流追踪状态",
                        ]
                    }
                ],
                spec: {
                    img: require('../../static/other/arrow.png'),
                    product: [
                        {
                            img: require('../../static/other/定制化解决方案.svg'),
                            title: "定制化解决方案",
                            contents: ["提供完全定制化的软件开发服务", "确保软件功能与业务流程完美契合", "最大化提升工作效率和业务价值"]
                        },
                        {
                            img: require('../../static/other/企业级安全保障.svg'),
                            title: "企业级安全保障",
                            contents: ["采用行业领先的安全技术和加密标准", "提供从代码到基础设施的全方位安全防护", "确保客户数据和业务系统免受威胁"]
                        },
                        {
                            img: require('../../static/other/高性能与可扩展性.svg'),
                            title: "高性能与可扩展性",
                            contents: ["采用现代化架构设计", "能够轻松应对高并发场景", "支持快速横向扩展，伴随企业成长"]
                        },
                        {
                            img: require('../../static/other/全天候技术支持.svg'),
                            title: "全天候技术支持",
                            contents: ["提供7×24小时专业运维支持服务", "快速响应客户需求，及时解决系统问题", "确保业务连续性和系统稳定性"]
                        }
                    ]
                },
                company: [
                    "企业从事于：互联网整合营销，互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
                    "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
                    "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
                    "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
                ],
                carousel_height: '550px',
            }
        },
        methods: {},
        mounted() {
            this.sliders = [
                {
                    img: require("../../static/slider/1.png")
                },
                {
                    img: require("../../static/slider/2.png")
                },
                {
                    img: require('../../static/slider/3.png')
                },
                {
                    img: require('../../static/slider/4.png')
                }
            ]
        },
        computed: {
            // 计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>
    .border_parent {
        width: 90%;
        margin: auto;
    }

    .carousel-container {
        width: 100%;
        max-width: 90%; /* 最大宽度限制 */
        margin: 0 auto; /* 居中 */
        padding: 20px 0;
    }

    /* 图片容器 */
    .image-container {
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        width: 100%;
        height: 100%;
        background-color: #f5f7fa; /* 加载时的背景色 */
    }

    /* 图片样式 */
    .slider_img {
        width: 100%; /* 80%宽度 */
        height: auto; /* 高度自适应 */
        object-fit: contain; /* 保持图片比例 */
        border-radius: 8px; /* 轻微圆角 */
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 轻微阴影 */
        transition: transform 0.3s ease; /* 悬停动画 */
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 50px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        margin-left: 10%;
        font-size: 1.125em;
        float: left;
        text-align: left;
    }
    .border_spec_inner_mid {
        margin-top: 15px;
        margin-left: 10%;
        font-size: 1.125em;
        float: left;
        text-align: left;
    }
    .border_spec_inner_last {
        margin-top: 15px;
        margin-left: 10%;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: left;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        /*display: flex;*/
        /*margin-top: 30px;*/
        /*justify-content: center;*/
        /*width: 100%;*/
        margin-top: 50px;
        margin-bottom: 10px
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            /*margin-top: 10px;*/
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5em;
    }

    .about-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 30px;
    }

    .about-text {
        flex: 0 0 80%;
        min-width: 300px;
        padding: 0 20px;
    }

    .about-image {
        flex: 1;
        min-width: 300px;
        height: 350px;
        background: url('https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80') no-repeat center center/cover;
        border-radius: 10px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }

    .values {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 30px;
        margin-top: 30px;
    }

    .value-card {
        background: white;
        border-radius: 10px;
        padding: 30px;
        width: 300px;
        text-align: center;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
        transition: transform 0.3s ease;
    }

    .value-card:hover {
        transform: translateY(-10px);
    }

    .value-icon {
        font-size: 40px;
        color: #1a6fc4;
        margin-bottom: 20px;
    }

    .value-card h3 {
        margin-bottom: 15px;
        color: #2c3e50;
    }
</style>